import { checkResponse } from "src/components/js/statics1";
import foreignKeyClass from "../foreignKeyClass";
import returnMessageClass from "../system/returnMessageClass";
import tuoteClass, { laskuTuoteClass } from "./tuoteClass.";

import {
  cache_clear,
  cache_read,
  cache_write,
  tuote_cacheName,
} from "src/components/js/CacheFunctions";

export async function tuote_fetch(tuoteId, token) {
  try {
    const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/tuotteet/get/" + tuoteId;
    const c = cache_read(tuote_cacheName, fullUrl);
    if (c) return c;
    const requestOptions = {
      method: "GET",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(fullUrl, requestOptions);
    const cResponse = await checkResponse(response, "laskuTuoteClass:fetchTuote");
    if (cResponse.success) {
      const result = cResponse.data;
      const _tuoteData = result[0][0];
      const _foreignKeysData = result[1];
      const _tuote = new tuoteClass(_tuoteData.laskuttajaAsiakasId, _tuoteData.tuoteTypeId);
      _tuote.tuoteId = _tuoteData.tuoteId;
      _tuote.nimike = _tuoteData.nimike;
      _tuote.lisäNimike = _tuoteData.lisäNimike;
      _tuote.yksikkö = _tuoteData.yksikkö;
      _tuote.tuoteTypeId = _tuoteData.tuoteTypeId;
      _tuote.määräKaava = _tuoteData.määräKaava;
      _tuote.aktiivinen = _tuoteData.aktiivinen;
      _tuote.kustannusPaikkaEval = _tuoteData.kustannusPaikkaEval;
      _tuote.alv = _tuoteData.alv;
      _tuote.hinta = _tuoteData.hinta;
      _tuote.orderNum = _tuoteData.orderNum;
      _tuote.tuoteCatTypeId = _tuoteData.tuoteCatTypeId;
      _tuote.tuoteCatTypeName = _tuoteData.tuoteCatTypeName;
      _tuote.kommentti = _tuoteData.kommentti;
      _tuote.foreignKeys = [];
      for (let i = 0; i < _foreignKeysData.length; i++) {
        const _foreignKeyData = _foreignKeysData[i];
        const _foreignKeyClass = new foreignKeyClass(_tuote.tuoteId);
        _foreignKeyClass.foreignKey = _foreignKeyData.foreignKey;
        _foreignKeyClass.foreignKeySourceId = _foreignKeyData.foreignKeySourceId;
        _foreignKeyClass.foreignKeySourceName = _foreignKeyData.foreignKeySourceName;
        _foreignKeyClass.asiakasId = _foreignKeyData.asiakasId;
        _tuote.foreignKeys.push(_foreignKeyClass);
      }
      cResponse.data = _tuote;
      cResponse.success = true;
      cResponse.message = "Tuote fetch successful";
    } else {
      cResponse.success = false;
      cResponse.message = "Tuote fetch failed";
    }
    cache_write(tuote_cacheName, fullUrl, cResponse, 360);

    return cResponse;
  } catch (error) {
    const returnMessage = new returnMessageClass("laskuTuoteClass:fetchTuote");
    returnMessage.success = false;
    returnMessage.error = error;
    returnMessage.message = "Tuote fetch failed";
    console.log(error);
    return returnMessage;
  }
}

export async function tuote_fetchList(asiakasId, token) {
  try {
    const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/tuotteet/list/" + asiakasId;
    const c = cache_read(tuote_cacheName, fullUrl);
    if (c) return c;
    const requestOptions = {
      method: "GET",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(fullUrl, requestOptions);
    const cResponse = await checkResponse(response, "laskuTuoteClass:fetchTuoteList");

    if (cResponse.success) {
      const data = cResponse.data[0];
      cResponse.returnMessage.data = data;
      cResponse.returnMessage.success = true;
      cResponse.returnMessage.message = "Tuote list fetch successful";
    }
    cache_write(tuote_cacheName, fullUrl, cResponse.returnMessage, 360);
    return cResponse.returnMessage;
  } catch (error) {
    const returnMessage = new returnMessageClass("laskuTuoteClass:fetchTuoteList");
    returnMessage.success = false;
    returnMessage.error = error;
    returnMessage.message = "Tuote list fetch failed";
    console.log(error);
    return returnMessage;
  }
}

export async function tuote_delete(tuoteId, token) {
  try {
    cache_clear(tuote_cacheName);
    const requestOptions = {
      method: "DELETE",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        laskuTuoteId: tuoteId,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/tuotteet/delete/" + tuoteId,
      requestOptions
    );
    const cResponse = await checkResponse(response, "laskuTuoteClass:deleteTuote");
    if (cResponse.success) {
      cResponse.returnMessage.message = "Tuote poisto onnistui";
      const data = cResponse.data;
      cResponse.returnMessage.data = data;
    } else {
      const _errMsg = cResponse.errorMessage;
      console.log(cResponse);
      if (_errMsg.includes("FK_keikkaLaskuRivit_tuotteet")) {
        cResponse.returnMessage.message =
          "Tuote on lisätty yhdelle tai useammalle laskulle ja sitä ei voida poistaa";
      } else {
        cResponse.returnMessage.message = cResponse.errorMessage;
      }
    }
    return cResponse.returnMessage;
  } catch (error) {
    console.log(error);
    const returnMessage = new returnMessageClass("laskuTuoteClass:deleteTuote");
    returnMessage.success = false;
    returnMessage.error = error;
    returnMessage.message = "Tuotteen poisto epäonnistui";
    return returnMessage;
  }
}

export async function tuote_save_to_db(tuote, token) {
  try {
    cache_clear(tuote_cacheName);
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(tuote),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/tuotteet/save",
      requestOptions
    );
    const cResponse = await checkResponse(response, "laskuTuoteClass:saveTuoteToDB");
    if (cResponse.success) {
      const data = cResponse.data;
      cResponse.returnMessage.data = data;
      cResponse.returnMessage.message = "Tallennus onnistui";
    }
    return cResponse.returnMessage;
  } catch (error) {
    const returnMessage = new returnMessageClass("laskuTuoteClass:saveTuoteToDB");
    returnMessage.success = false;
    returnMessage.error = error;
    returnMessage.message = "Tuote list fetch failed";
    console.log(error);
    return returnMessage;
  }
}

export async function tuote_saveForeignKey_to_db(
  tuoteId,
  foreignKeySourceId,
  foreignKey,
  asiakasId,
  token
) {
  try {
    cache_clear(tuote_cacheName);
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        tuoteId: tuoteId,
        foreignKeySourceId: foreignKeySourceId,
        foreignKey: foreignKey,
        asiakasId: asiakasId,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/tuotteet/saveForeignKey",
      requestOptions
    );
    const cResponse = await checkResponse(response, "laskuTuoteClass:saveForeignKey");
    if (cResponse.success) {
      const data = cResponse.data;
      cResponse.returnMessage.data = data;
      cResponse.returnMessage.message = "Tallennus onnistui";
    }
    return cResponse.returnMessage;
  } catch (error) {
    const returnMessage = new returnMessageClass("laskuTuoteClass:saveTuoteToDB");
    returnMessage.success = false;
    returnMessage.error = error;
    returnMessage.message = "Tuote list fetch failed";
    console.log(error);
    return returnMessage;
  }
}

export async function tuote_create(laskuttajaAsiakasId, token) {
  return await tuote_save_to_db(new laskuTuoteClass(laskuttajaAsiakasId).laskuTuote, token);
}

export async function tuote_getCatTypes(token) {
  try {
    const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/tuotteet/getCatTypes";
    const c = cache_read(tuote_cacheName, fullUrl);
    if (c) return c;
    const requestOptions = {
      method: "GET",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(fullUrl, requestOptions);
    const cResponse = await checkResponse(response, "laskuTuoteClass:getCatTypes");
    if (cResponse.success) {
      const data = cResponse.data;
      cResponse.returnMessage.data = data;
      cResponse.returnMessage.success = true;
      cResponse.returnMessage.message = "Tuote catTypes fetch successful";
    }
    cache_write(tuote_cacheName, fullUrl, cResponse.returnMessage, 360);
    return cResponse.returnMessage;
  } catch (error) {
    const returnMessage = new returnMessageClass("laskuTuoteClass:getCatTypes");
    returnMessage.success = false;
    returnMessage.error = error;
    returnMessage.message = "Tuote catTypes fetch failed";
    console.log(error);
    return returnMessage;
  }
}
